import Image from "next/image";
import imgLogoGhg from "@/img/logo-ghg.png";
import imgLogoTcfd from "@/img/logo-tcfd.png";
import imgLogoCdp from "@/img/logo-cdp.png";
import imgLogoSasb from "@/img/logo-sasb.png";

export default function StandardsLogos() {
  return (
    <>
      <div className="standards">
        <div>
          <a href="https://ghgprotocol.org/" target="_blank" rel="noreferrer">
            <Image src={imgLogoGhg} alt="Greenhouse Gas Protocol" />
          </a>
        </div>
        <div>
          <a href="https://www.cdp.net/en" target="_blank" rel="noreferrer">
            <Image
              src={imgLogoCdp}
              alt="CDP"
              objectPosition="center"
              objectFit="contain"
              height={40}
            />
          </a>
        </div>
        <div>
          <a href="https://www.sasb.org/" target="_blank" rel="noreferrer">
            <Image
              src={imgLogoSasb}
              alt="SASB"
              objectPosition="center"
              objectFit="contain"
              height={68}
            />
          </a>
        </div>
        <div>
          <a href="https://www.fsb-tcfd.org/" target="_blank" rel="noreferrer">
            <Image
              src={imgLogoTcfd}
              alt="Task Force on Climate-Related Financial Disclosures"
            />
          </a>
        </div>
      </div>
      <style jsx>{`
        .standards {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-template-rows: repeat(2, 1fr);
          gap: 2px;
          background-color: #e3e7ee;
        }
        .standards > div {
          background-color: var(--module-color, #f0f3f7);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 36px 24px;
        }
      `}</style>
    </>
  );
}
